module.exports = __webpack_public_path__ + "static/media/image-mask-small.f8788551.svg";